import axios from "axios";
import authHeader from "./auth-header";
import IServiceOrder from "../types/service-order.type";
import IServiceOrderState from "../types/service-order-change-status.type";
import IServiceOrderChangeStatus from "../types/service-order-change-status.type";
import {ProfileFileNames} from "../types/enumeration/ProfileFileNames";
import IServiceOrderAttachment from "../types/service-order-attachment.type";

const API_URL = `${process.env.REACT_APP_SERVER_URL}/service-order`;

export const getById = (id: any) => {
  return axios.get(API_URL + "/" + id, { headers: authHeader() });
};

export const create = (serviceOrder: IServiceOrder) => {
  return axios.post(API_URL, serviceOrder, { headers: authHeader() });
};

export const update = (id: number, serviceOrder: IServiceOrder) => {
  return axios.put(API_URL + "/" + id, serviceOrder, { headers: authHeader() });
};

export const deleteById = (id: any) => {
  return axios.delete(API_URL + "/" + id, { headers: authHeader() });
};

export const changeStatus = (id: any, serviceOrderChangeStatus: IServiceOrderChangeStatus) => {
  return axios.put(API_URL + "/" + id + "/change-status", serviceOrderChangeStatus, { headers: authHeader() });
};

export const getServiceOrders = (params: {}) => {
  return axios.get(API_URL, { params: params, headers: authHeader() });
};

export const getMyServiceOrders = (params: {}) => {
  return axios.get(API_URL + "/my-service-orders", { params: params, headers: authHeader() });
};

export const confirmReception = (id: any) => {
  return axios.put(API_URL + "/" + id + "/confirm-reception", {}, { headers: authHeader() });
};

export const findServiceOrders = (params: {}) => {
  return axios.get(API_URL + "/find", { params: params, headers: authHeader() });
};

export const uploadAttachment = (id: number, serviceOrderAttachment: IServiceOrderAttachment) => {
  const headers = authHeader();
  headers['Content-Type'] = 'multipart/form-data';

  const formData = new FormData();

  if (serviceOrderAttachment.uploadAttachment) {
    formData.append("uploadAttachment", serviceOrderAttachment.uploadAttachment);
  }
  formData.append("description", serviceOrderAttachment.description);

  return axios.put(API_URL + "/" + id + "/attach-document", formData, { headers: headers });
};
